module.exports = __webpack_public_path__ + "img/sos-type-brown.147fb820.png";